import Vue from "vue";

export const
    InsurStore = Vue.observable({
        applicantCode: '', //验证码
        merchantMap: {}, //服务机构信息
        name:'', //姓名
        idCard:'', // 身份证号
        newProtocolModalShow: false, //用来标记“请认真阅读并同意以下协议弹窗”是否显示
    });

export const
    InsurMutations = {
        // 验证码信息存储
        setApplicantCode(parme) {
            InsurStore.applicantCode = parme;
        },
        // 服务机构信息存储 
        setMerchantMap(parme) {
            InsurStore.merchantMap = parme;
        },
         // 姓名信息存储 
         setName(parme) {
            InsurStore.name = parme;
        },
         // 身份证号信息存储 
         setIdCard(parme) {
            InsurStore.idCard = parme;
        },
        // 用来存储“请认真阅读并同意以下协议弹窗”是否显示的标记
        setNewProtocolModalShow(parme) {
            InsurStore.newProtocolModalShow = parme;
        },
    };